import React from 'react';

import { graphql } from 'gatsby';

import { styled } from '@mui/material';

import { StrapiImage } from '../../dynamic-content-page/content-components/image';
import { AuthorBoxBase } from '../types';
import { AuthorReference } from './author-reference';

export type AuthorBoxProps = AuthorBoxBase & {
  authorLink?: string;
  translations: {
    author_box_by: string;
  };
  className?: string;
};

export const query = graphql`
  fragment AuthorBoxFragment on STRAPI_BLOG_AUTHOR {
    name
    position
    image {
      ...StrapiImageFileFragment
    }
  }
`;

export const AuthorBox = React.memo(
  ({
    name,
    position,
    image,
    authorLink,
    translations,
    className = '',
  }: AuthorBoxProps) => {
    return (
      <div className={className}>
        <StrapiImage
          alt={name}
          image={image}
          style={{
            width: '100px',
            height: '100px',
            borderRadius: '50px',
            marginBottom: '16px',
          }}
        />
        <Subline>
          <AuthorReference
            authorLink={authorLink}
            name={name}
            translations={translations}
          />
          , <span>{position}</span>
        </Subline>
      </div>
    );
  },
);

const Subline = styled('span')(({ theme }) => ({
  ...theme.typography.body,

  [theme.breakpoints.up('sm')]: {
    fontSize: '16px',
  },

  [theme.breakpoints.up('lg')]: {
    fontSize: '18px',
  },
}));
